import * as React from 'react';
import { Spinner, Intent, Callout, H2, H3, Button } from '@blueprintjs/core';
import { executeQueryAuthPostForm, executeQueryGetAuth, executeQueryPost } from 'app/utils/api';
import { UserState } from 'app/reducers/state';
import ReactCodeInput from 'react-code-input';

interface Props {
    user: UserState;
    classProduct: string; // example of this would be "4"
    onSelected: () => void;
};

interface State {
    loadingPurchaseData: boolean;
    showCertificate: boolean;
    wantsCertificate: boolean;
    selectedManualCode: boolean;
    showCart: boolean;
    waitingForPaypal: boolean;
    processing: boolean;
    codeState: string;
    purchaseData: {
        description: string,
        id: number,
        modal: string,
        name: string,
        price: string,
        sku: string,
        type: string
    } | undefined;
}

export class Subscription extends React.Component<Props, State> {

    state: State = {
        loadingPurchaseData: true,
        purchaseData: undefined,
        showCertificate: false,
        waitingForPaypal: false,
        wantsCertificate: false,
        selectedManualCode: false,
        showCart: false,
        codeState: '',
        processing: false
    }

    componentDidMount() {
        executeQueryGetAuth("transactions/product/" + this.props.classProduct, {}, this.props.user, (data) => {
            this.setState({
                loadingPurchaseData: false,
                purchaseData: data.body
            });
        });
    }

    renderFormattedPrice = () => {
        const {
            purchaseData
        } = this.state;

        return "$" + parseFloat(purchaseData!.price).toFixed(2).toString();
    }

    getTotalPrice = () => {
        const {
            purchaseData,
            wantsCertificate
        } = this.state;

        const certificateprice = wantsCertificate ? 9.99 : 0.0;

        return parseFloat(purchaseData!.price) + certificateprice;
    }

    handlePurchase = () => {
        const {
            wantsCertificate
        } = this.state;

        this.setState({
            waitingForPaypal: true
        });

        const userID = this.props.user.id;
        const products = this.props.classProduct + (wantsCertificate ? ",1" : "");

        executeQueryPost("transactions/singlecall", {
            user: userID,
            products
        }, (response) => {
            // Navigate to the payload location
            window.location.href = response.body.href;
        })
    }

    renderTotalPrice = () => {
        const price = this.getTotalPrice();

        return "$" + price.toFixed(2).toString();
    }

    renderNormalButton = (rightIcon: any, onClick: any, intent: any, text: string) => {
        return <Button style={{ width: '100%', marginTop: '20px' }} rightIcon={rightIcon} onClick={() => { onClick(); }} intent={intent} text={text} />
    }

    renderPurchaseStage = () => {
        const {
            showCertificate,
            showCart,
            selectedManualCode,
            processing
        } = this.state;

        const {
            user
        } = this.props;

        if (selectedManualCode) {
            if (processing) {
                return <span style={{ width: '400px', display: 'block', margin: 'auto' }}>
                    <div style={{
                        marginTop: '20px'
                    }}>
                        <Spinner />
                    </div>
                </span>
            }
            return this.renderManualCodeWidget(user.id);
        }

        if (showCart) {
            return this.renderCartWidget();
        }

        if (showCertificate) {
            return this.renderCertificateWidget();
        }

        return this.renderProductWidget();
    }

    renderManualCodeWidget = (userID) => {
        return <span style={{ width: '400px', display: 'block', margin: 'auto' }}>
            <p>vLeader Softare Code Redemption</p>
            <p>If you recieved a code to redeem this software this is the location to enter it.</p>

            <ReactCodeInput onChange={(value) => {
                this.setState({
                    codeState: value
                })
            }} name="text-input" value={this.state.codeState} inputMode="verbatim" type='text' fields={8} />

            <hr></hr>

            {this.renderNormalButton(undefined, () => {
                this.setState({
                    processing: true
                });

                try {
                    executeQueryAuthPostForm("transactions/code/consume", {
                        user: userID,
                        code: this.state.codeState
                    }, (response) => {
                        window.location.reload();
                    });
                }
                catch (e) {

                }
            }, Intent.SUCCESS, "Enter")}

            {this.renderNormalButton(undefined, () => {
                this.setState({
                    showCertificate: false,
                    waitingForPaypal: false,
                    wantsCertificate: false,
                    selectedManualCode: false,
                    showCart: false
                });
            }, Intent.NONE, "Cancel")}
        </span>
    }

    renderCartWidget = () => {
        const {
            purchaseData,
            wantsCertificate
        } = this.state;

        return <span style={{ width: '400px', display: 'block', margin: 'auto' }}>
            <H2>Cart</H2>
            <br />
            <div className="cart-block">
                <div style={{ display: 'block', width: '100%', height: '100%', padding: '5px', border: '1px solid #c5c5c5', borderRadius: '3px' }}>
                    <table className="pure-table pure-table-horizontal cart-table">
                        <tbody>
                            <tr>
                                <th>Item</th>
                                <th>Price</th>
                            </tr>
                            <tr>
                                <td>{purchaseData!.name}</td>
                                <td>{this.renderFormattedPrice()}</td>
                            </tr>
                            {wantsCertificate ? <tr>
                                <td>vLeader Certificate</td>
                                <td>$9.99</td>
                            </tr> : undefined}
                            <tr>
                                <th colSpan={1}><span className="pull-right">Total</span></th>
                                <th >{this.renderTotalPrice()}</th>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <img style={{ width: '200px' }} className="pull-right shopping-button" onClick={() => {
                    this.handlePurchase();
                }} src="https://s3.us-east-2.amazonaws.com/portal.vleader.net/assets/img/checkout-logo-large.png" />
                <div className="clearfix"></div>
            </div>
        </span>
    }

    renderCertificateWidget = () => {
        const certificateDescription = <p>
            This is a one-time offer.

            SimuLearn Certificates offer you a valuable and unique opportunity to demonstrate your desire and ability to lead others and work collaboratively in a team. You can place your Certificate level on your CV or resume and when asked, SimuLearn will support your claim. Employers find team and leadership skills as highly attractive quality as the need to find people who can quickly operate in rapidly forming teams, increases. They also are seeking employees who are able to take responsibility for outcomes for which SimuLearn program and research has demonstrated that performance in SimuLearn programs has a direct correlation to team members' perception of an individual's team and leaders skills.

            In addition, the purchase of this certificate, now or in the future will also enroll you in the SimuLearn Team and Leader Scholarship. See http://www.simulearn.net/scholarship.html for more details

            You have the opportunity to pre-purchase your certificate at the discounted rate of $9.99 now or later on you can purchase it for $19.99. Various certificates are available based upon your accomplishments in the program see http://www.simulearn.net/web/awards.html for more details

            If you need more information contact: certificates@simulearn.net
        </p>

        return <span style={{ width: '400px', display: 'block', margin: 'auto' }}>
            <H2 style={{ float: 'left' }}>vLeader Certificate</H2>
            <div className="clearfix" />
            <ul className="list-unstyled text-left">
                {certificateDescription}
            </ul>

            {this.renderNormalButton(undefined, () => {
                this.setState({
                    wantsCertificate: true,
                    showCart: true
                });
            }, Intent.SUCCESS, "Add To Cart")}

            {this.renderNormalButton(undefined, () => {
                this.setState({
                    wantsCertificate: false,
                    showCart: true
                });
            }, Intent.NONE, "No Thank You")}
        </span>
    }

    renderProductWidget = () => {
        const {
            purchaseData
        } = this.state;

        return <span style={{ width: '400px', display: 'block', margin: 'auto' }}>
            <H2 style={{ float: 'left' }}>{purchaseData!.name}</H2>
            <H3 style={{ float: 'right' }}>${purchaseData!.price}</H3>
            <div className="clearfix" />
            <ul className="list-unstyled text-left">
                <li><i className="fa fa-check text-success"></i><strong>vLeader</strong> for New Millenium Software</li>
                <li><i className="fa fa-check text-success"></i><strong>vLeader</strong> eText</li>
                <li><i className="fa fa-check text-success"></i><strong>Compilimentary</strong> Tech Support</li>
                <li><i className="fa fa-check text-success"></i><strong>Online</strong> Data Submission</li>
                <li><i className="fa fa-check text-success"></i><strong>Roaming</strong> Access</li>
            </ul>

            {this.renderNormalButton(undefined, () => {
                this.setState({
                    showCertificate: true
                });
            }, Intent.SUCCESS, "Add To Cart")}
        </span>
    }

    render() {
        const {
            loadingPurchaseData,
            selectedManualCode,
            waitingForPaypal
        } = this.state;

        if (loadingPurchaseData || waitingForPaypal) {
            return <Spinner />
        }

        return <span>
            <Callout style={{ marginBottom: '20px', marginTop: '20px' }} icon="info-sign" intent={Intent.PRIMARY} title={"Getting Started"}>
                You need to purchase a license for vLeader before continuing.
            </Callout>

            {selectedManualCode ? undefined : <Button style={{ margin: '10px' }} onClick={() => { this.setState({ selectedManualCode: true }) }} intent={Intent.PRIMARY} large={true} text={"I have a Code"} />}

            {this.renderPurchaseStage()}
        </span>
    }
}
